enum constants {
  POST = "POST",
  GET = "GET",
  DELETE = "DELETE",
  PUT = "PUT",
  WEB = "WEB",
  AUTH_TOKEN = "auth_orca",
  ORCA_USER = "ORCA_USER",
  ORDER_FILTER_SETTINGS = "ORDER_FILTER_SETTINGS",
  GLOBAL_PREFERENCES = "GLOBAL_PREFERENCES",
  ACTIVE_SUBSCRIPTION_CUSTOMERS = "ACTIVE_SUBSCRIPTION_CUSTOMERS",
  ORCA = "ORCA",
  ADMIN = "ADMIN",
  PATCH = "PATCH",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export const META_INFO_KEYS = {
  CANCELLED_AT: "cancelledAt",
  SUPPLIER_ALLOCATION_TIME: "supplierAllocationTime",
  READY_TO_DISPATCH_TIME: "readyToDispatchTime",
  CUSTOMER_HOLD_START_TIME: "customerHoldStartTime",
  CUSTOMER_HOLD_END_TIME: "customerHoldEndTime",
  ESTIMATE_SHARED_AT: "estimateSharedAt",
  REQUIRE_PRICE_ESTIMATE_POST_ENQUIRY_PLACED:
    "requirePriceEstimatePostEnquiryPlaced",
} as const;

/** Matches Backend `SYSTEM_USER_ID` — system-driven timeline / soft-delete actor. */
export const SYSTEM_USER_ID = "6a0473f85128d927033f1271";

export default constants;
